import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.5rem 0;

  @media (min-width: 1200px) {
    flex-wrap: nowrap;
  }
`;

export const Field = styled.div`
  min-width: ${props => props.minWidth || '200px'};
  flex: 1 1 ${props => props.minWidth || '200px'};

  @media (min-width: 1200px) {
    flex: 0 0 ${props => props.minWidth || '200px'};
  }
`;

export const CheckboxField = styled(Field)``;

export const Actions = styled.div`
  flex: 0 0 auto;
  margin-top: 1.7rem;
`;

export const SecondaryAction = styled(Actions)`
  margin-left: auto;
  padding-left: 2rem;
`;
